<template>
    <div class="animated fadeIn"
        v-on:keyup.enter="InserirOuEditar">
      <b-row>
        <b-col sm="12" >
          <div class="fright margin-5-bottom">
              <b-button variant="secondary" class="btn-square margin-5-right" @click="Voltar" >Cancelar</b-button>
              <botao-duplo-clique variant="success" @click="InserirOuEditar" ref="botaoSalvar"/>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col >
          <b-card>
            <div slot="header">
              <strong>Centro de custos </strong><small>{{centroDeCustoId != null ? "Edição" : "Inserção"}}</small>
            </div>
            <b-row>
              <b-col sm="6">
                <validator prop-name="Descricao" :erros="erros" campo-descritivo="* Descrição">
                  <b-form-input v-model="Descricao"
                    type="text"
                    id="Descricao"
                    slot="component"
                    placeholder="Digite uma Descrição "></b-form-input>
                </validator>
              </b-col>
              <div class="col-sm-12 col-md-2 col-lg-2 col-xl-2">
              <div class="form-group">
                <label for="Cor">* Cor</label>
                <input
                  id="Cor"
                  v-model="Cor"
                  class="form-control"
                  placeholder="Cor"
                  required
                  type="color"
                />
              </div>
            </div>
          </b-row>
          <b-row>
          <b-col sm="6">

            <div class="form-group">
              <label for>Hospitais</label>
              <v-select
              v-model="vSelect.selectedOptions"
              placeholder="Selecione os hospitais vinculados a este centro de custo"
              :options="vSelect.clientesOptions"
              multiple
              >
              <template slot="no-options">
                Nenhum Resultado
              </template>
            </v-select>
          </div>
        </b-col>
        </b-row>
          
  
              
          </b-card>
        </b-col>
      </b-row>
    </div>
  </template>
  
  <script>
  import { Switch as cSwitch } from '@coreui/vue'
  
  export default {
    name: 'novo-centro-de-custo',
      components:{
        cSwitch
    },
    computed:{
      now(){
        var date = new Date()
        return date.toISOString().split('T')[0]
      },
      CentroCustoViewModel(){
        var vm =this
  
        let selectedCliente = this.vSelect.selectedOptions;

        return {
          Id: this.centroDeCustoId || this.$uuid.v4(),
          ContaId: this.$store.getters.getAutenticacao.contaId,
          Descricao: this.Descricao,
          Cor: this.Cor,
          Cliente: selectedCliente,
          UsuarioCadastroId: this.usuarioDeCadastroId,
          DataCadastro: this.dataDeCadastro,
        }
      }
    },
    created() {
      this.GetCentroDeCusto()
      this.getClienteVSelect()
      if(!this.centroDeCustoId) this.dataDeCadastro= this.now
    },
    data() {
      return {
        options: [],
          centroDeCustoId: this.$route.params.id || null,
          usuarioDeCadastro: this.$store.getters.getAutenticacao.apelido,
          usuarioDeCadastroId: this.$store.getters.getAutenticacao.usuarioId,
          dataDeCadastro: this.now,
          Descricao: "",
          Cor: "#321fdb",
          erros: [],
          vSelect: {
            selectedOptions: undefined,
            clientesOptions: []
          }
      }
    },
    methods: {
      Voltar(){
        this.$router.push('/centro-de-custos/1')
      },
      async getClienteVSelect() {
      return this.$http({
        url: "cliente/obter-select2/"+this.$store.getters.getAutenticacao.contaId,
        method: "GET",
        data: this.filters
      })
        .then((resp) => {
          this.vSelect.clientesOptions = resp.data;
        })
        .catch((err) => {
          this.$notify({
            data: err.response.data.erros,
            type: "warn",
            duration: 10000
          });
        });
    },
      GetCentroDeCusto(){
        if(this.centroDeCustoId == null ) return
        var vm = this
        this.$http({url: '/centro-de-custo/editar/' +  this.$route.params.id + "/" + this.$store.getters.getAutenticacao.contaId , method: 'GET' })
          .then(response => {
            vm.usuarioDeCadastroId = response.data.usuarioCadastroId
            vm.usuarioDeCadastro = response.data.usuarioCadastro
            vm.dataDeCadastro = response.data.dataCadastro
            vm.Descricao =  response.data.descricao
            vm.Cor = response.data.cor
            vm.vSelect.selectedOptions = response.data.cliente
        })
        .catch(err => {
            this.$router.push('/500')
        })
      },
      InserirOuEditar(){
        if(this.centroDeCustoId != null ){
          this.Editar()
          return
        }
  
        this.Inserir()
      },
      Editar(){
        var vm = this
        this.$http({url: '/centro-de-custo/editar', data: this.CentroCustoViewModel, method: 'PUT'  })
          .then(response => {
            if(!response.data.sucesso){
              vm.erros = response.data.erros
              vm.$refs.botaoSalvar.unloading()
              return
            }
            this.$store.commit("set_mensagem",{tipo: "success", mensagem: "O centro de custo foi editado com sucesso!"})
            this.$router.push('/centro-de-custos/1')
        })
        .catch(err => {
            this.$store.commit("set_mensagem",{tipo: "danger", mensagem: err.response.data.errors})
            this.$router.push('/centro-de-custos/1')
        })
      },
      Inserir(){
        var vm = this
        this.$http({url: '/centro-de-custo/novo', data: this.CentroCustoViewModel, method: 'POST'  })
          .then(response => {
            if(!response.data.sucesso){
              vm.erros = response.data.erros
              vm.$refs.botaoSalvar.unloading()
              return
            }
            this.$store.commit("set_mensagem",{tipo: "success", mensagem: "O centro de custo foi salvo com sucesso!"})
            this.$router.push('/centro-de-custos/1')
        })
        .catch(err => {
            this.$store.commit("set_mensagem",{tipo: "danger", mensagem: err.response.data.errors})
            this.$router.push('/centro-de-custos/1')
        })
      },
    },
  }
  </script>